export default __webpack_public_path__ + "static/team1-766aee09a3ef29833279b98c07b15c29.jpg";